import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { first } from 'rxjs/operators';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';

import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  LoginForm: FormGroup;

  account: string;

  password: string;

  returnUrl: string;

  error = '';

  constructor(
    // private AuthService: AuthService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
  ) {
    this.LoginForm = this.fb.group({
      account: ['', [Validators.required]],//必填
      password: ['', [Validators.required]],//必填
    });
  }

  ngOnInit(): void {

  }

  login(): void {

    // console.log(this.LoginForm.value)

    this.authenticationService.login(this.LoginForm.get('account').value, this.LoginForm.get('password').value)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data)
          if (data.code != 200) {
            this.messageService.add({ severity: 'error', summary: '失敗', detail: data.detailed });
          }
          this.router.navigate(['/main/dashboard']);
        },
        error => {
          console.log(error)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Account or password is incorrect' });
        }
      );
  }

  forgot() {
    this.messageService.add({ severity: 'warn', summary: '注意', detail: '請洽公司權限管理人員' });
  }

}
